(function () {
	window.js = window.js || {};
	js.cookieWarning = (function () {
		function initialize(domElm) {
			var oCookie = document.querySelectorAll('[data-cookie]');

		    var nCookie = oCookie.length;
			    while (nCookie--) {
			        oCookie[nCookie].addEventListener('click', function(e){
			            cookieHandler(this);
			    });
			}

			function cookieHandler(oCookie) {
				var
				sCls = oCookie.dataset.cookieCls,
				sElm = oCookie.dataset.cookieElm,
				sName = oCookie.dataset.cookie,
				sVal = oCookie.dataset.cookieVal,
				oElm = document.querySelector(sElm);

				if (oElm) oElm.classList.add(sCls);

				utils.cookie.set(sName, sVal);
			}

		}
		return {
			initialize: initialize
		};

	})();
})();